"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockEnvironmentVariableCollection = void 0;
class MockEnvironmentVariableCollection {
    constructor() {
        this.persistent = true;
        this.variables = {};
    }
    append(variable, value) {
        const envVar = this.variables[variable];
        if (envVar === undefined) {
            this.variables[variable] = value;
        }
        else {
            this.variables[variable] = this.variables[variable] + value;
        }
    }
    get(variable) {
        throw new Error('Method not implemented.');
    }
    replace(variable, value) {
        this.variables[variable] = value;
    }
    prepend(variable, value) {
        throw new Error('Method not implemented.');
    }
    forEach(callback, thisArg) {
        throw new Error('Method not implemented.');
    }
    delete(variable) {
        throw new Error('Method not implemented.');
    }
    clear() {
        throw new Error('Method not implemented.');
    }
    [Symbol.iterator]() {
        throw new Error('Method not implemented.');
    }
}
exports.MockEnvironmentVariableCollection = MockEnvironmentVariableCollection;
//# sourceMappingURL=MockEnvironmentVariableCollection.js.map